import { makeStyles } from '@paintscout/ui'
import { useDialogs } from '@paintscout/ui-business'
import { track } from 'shared/util/analytics'

import React, { useEffect } from 'react'
import { useFlags } from 'shared/components/common/FlagsProvider'
import CRMPromptDialog from 'src/components/dialogs/CRMPromptDialog'

const useStyles = makeStyles((theme) => ({
  previewWrapper: {
    paddingTop: theme.spacing(4),
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: theme.paintscout.palette.brand?.Neutral?.P40,
      opacity: 0.5,
      zIndex: 1
    }
  },
  crmPrompt: {
    backgroundColor: theme.palette.background.paper,
    position: 'fixed',
    top: theme.spacing(12),
    left: '50%',
    width: '50rem',
    transform: 'translateX(-50%)',
    zIndex: 10,
    boxShadow: theme.shadows[24],
    borderRadius: theme.shape.borderRadius,
    pointerEvents: 'auto',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '70%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100vw',
      height: 'calc(100vh - 48px)',
      top: theme.spacing(6),
      boxShadow: 'none',
      position: 'absolute'
    }
  }
}))

interface CRMPromptPageProps {
  Background: React.ReactNode
}

export default function CRMPromptPage({ Background }: CRMPromptPageProps) {
  const classes = useStyles()
  const { openDialog, dismissDialog } = useDialogs()
  const { crm } = useFlags()

  useEffect(() => {
    track('CRMPromptDialogOpen - PromptPage')
    openDialog(CRMPromptDialog, { isPromptPage: true, hideBackdrop: true }, { replace: true })
  }, [])

  useEffect(() => {
    if (crm) {
      dismissDialog()
    }
  }, [crm])

  return (
    <>
      <div className={classes.previewWrapper}>{Background}</div>
    </>
  )
}
